export default __webpack_public_path__ + "static/media/naics.558e6359.csv";